import {Component, Injector, OnInit, ViewChild} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {PlayerBaseService} from '../../services/PlayerService/player.base.service';
import {Log, LogTag} from '../../services/Log';
import {PlayerPwaService} from "../../services/PlayerService/player.pwa.service";
import {concatMap, fromEvent, Observable, of, Subject, switchMap, takeWhile} from "rxjs";
import {take} from "rxjs/operators";
import {RegDialogComponent} from "../reg-dialog/reg.dialog.component";

@Component({
  selector: 'install-pwa',
  templateUrl: './install-pwa.component.html',
  styleUrls: ['../reg-dialog/reg.dialog.component.css', './install-pwa.component.css']
})
export class InstallPwaComponent extends RegDialogComponent implements OnInit {
  @ViewChild('clickInstall', {static: false} ) clickInstall;

  constructor(protected  injector: Injector) {
    super(injector);
  }

  ngOnInit() {
  }

  install(): Observable<any> {
    const logInfo = Log.getLogInfo("InstallPwaComponent", "install", []);
    return this.click$.pipe(
      take(1),
      switchMap( r => {
        Log.d(logInfo, LogTag.REGISTRATION, 'install click');
        this.disableUI(true);
        return (<PlayerPwaService>this.playerService).installPwa();
      })
    )
  }
}
